import cx from 'clsx';
import React, { type ReactElement } from 'react';

import style from './style.module.scss';

interface IProps {
  id?: string;
  type: 'primary' | 'secondary' | 'outline' | 'textRed';
  variant?: 'small' | 'medium' | 'full';
  text?: string;
  disabled?: boolean;
  leftElement?: ReactElement;
  rightElement?: ReactElement;
  dataTooltipId?: string;
  dataTooltipContent?: string;
  className?: string;
  dataQa?: string;
  onClick: () => void;
}

const Button: React.FC<IProps> = ({
  type,
  variant,
  text = '',
  id,
  disabled,
  leftElement,
  rightElement,
  dataTooltipId = '',
  dataTooltipContent = '',
  className,
  dataQa,
  onClick,
}) => (
  <button
    id={id}
    className={cx(
      style.btn,
      {
        [style.btnPrimary]: type === 'primary',
        [style.btnSecondary]: type === 'secondary',
        [style.btnOutline]: type === 'outline',
        [style.small]: variant === 'small',
        [style.medium]: variant === 'medium',
        [style.full]: variant === 'full',
      },
      className,
    )}
    disabled={disabled}
    onClick={onClick}
    data-tooltip-id={dataTooltipId}
    data-tooltip-content={dataTooltipContent}
    data-qa={dataQa}
  >
    {leftElement}
    {text}
    {rightElement}
  </button>
);

export default Button;
